import useAuth from "@/hooks/useAuth";
import React from "react";
import { RouteProps, Outlet, Navigate, useLocation } from "react-router-dom";

//@ts-ignore
interface ProtectedRouteProps extends RouteProps {
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();

  return allowedRoles.find((role) => auth.role === role) ? (
    <Outlet />
  ) : (
    <Navigate
      to='/inventory/stock-quantity'
      state={{ from: location }}
      replace
    />
  );
};

export default ProtectedRoute;
